import { Icon } from '@hotjar/hotsauce';
import { Cell } from './RecordingOverviewWidgetCell';

import type { RecordingOverviewWidgetCellParams } from './RecordingOverviewWidgetCell';

export const RecordingOverviewWidgetCellErrors = ({
  recording,
}: RecordingOverviewWidgetCellParams): JSX.Element | null => {
  if (!recording) return null;

  // @TODO When available, add the error count to the cell.
  return (
    <Cell>
      <Icon icon="code_dev" />
    </Cell>
  );
};
